<div class="reservation-container">
  <div class="reservation-topbar">
    <div class="topbar-left">
      <h1>
        Reservations
        <small>Manage equipment reservations for jobs, events, and customers</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> IMS / <span>Equipment Rental</span> / <span class="current">Reservations</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp() }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Search reservations..." [ngModel]="searchQuery()"
          (ngModelChange)="searchQuery.set($event)" />
      </div>
      <button class="btn btn-outline btn-sm" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
      <button class="btn btn-primary" (click)="openReservationModal()">
        <i class="bi bi-plus-circle"></i> New Reservation
      </button>
    </div>
  </div>

  <div class="flow-hint">
    <i class="bi bi-info-circle"></i>
    <span>{{ rentalFlowHint }}</span>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon blue">
        <i class="bi bi-calendar-event"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Total Reservations</div>
        <div class="stat-value">{{ reservationStats().total }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon green">
        <i class="bi bi-cash-coin"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Ready to issue</div>
        <div class="stat-value">{{ reservationStats().readyToIssue }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon blue">
        <i class="bi bi-box-arrow-up-right"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Issued out</div>
        <div class="stat-value">{{ reservationStats().issuedOut }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon amber">
        <i class="bi bi-clock"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Pending</div>
        <div class="stat-value">{{ reservationStats().pending }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon red">
        <i class="bi bi-x-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Cancelled</div>
        <div class="stat-value">{{ reservationStats().cancelled }}</div>
      </div>
    </div>
  </div>

  <div class="filter-bar">
    <div class="filter-left">
      <div class="filter-group">
        <label><i class="bi bi-tag"></i> Status</label>
        <select [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event)">
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="confirmed">Confirmed</option>
          <option value="completed">Ready to issue</option>
          <option value="issued">Issued out</option>
          <option value="cancelled">Cancelled</option>
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-building"></i> Branch</label>
        <select [ngModel]="branchFilter()" (ngModelChange)="branchFilter.set($event)">
          @if (!branchFilterLocked()) {
            <option value="all">All Branches</option>
          }
          @for (branch of branches(); track branch.id) {
            <option [value]="branch.name">{{ branch.name }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-geo-alt"></i> Location</label>
        <select [ngModel]="locationFilter()" (ngModelChange)="locationFilter.set($event)">
          <option value="all">All Locations</option>
          @for (location of locations(); track location.id) {
            <option [value]="location.name">{{ location.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="filter-right">
      <span class="filter-count">Showing {{ filteredReservations().length }} reservations</span>
    </div>
  </div>

  <div class="table-wrap">
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>Reservation ID</th>
            <th>Customer</th>
            <th>Equipment</th>
            <th>Qty</th>
            <th>Branch</th>
            <th>Location</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (reservation of filteredReservations(); track reservation.id) {
          <tr>
            <td><span class="reservation-id">{{ reservation.reservationNumber }}</span></td>
            <td>{{ reservation.customer }}</td>
            <td>
              <div class="item-info">
                <span class="item-icon"><i class="bi" [class]="findAssetIcon(reservation.equipment)"></i></span>
                <span>{{ reservation.equipment }}</span>
              </div>
            </td>
            <td>{{ reservation.quantityRequested ?? 1 }}</td>
            <td><span class="branch-tag">{{ reservation.branch }}</span></td>
            <td><span class="location-tag">{{ reservation.location }}</span></td>
            <td>{{ formatDate(reservation.startDate) }}</td>
            <td>{{ formatDate(reservation.endDate) }}</td>
            <td><span class="status-badge" [class]="reservation.status">{{ reservationStatusLabel(reservation.status) }}</span></td>
            <td class="actions-cell">
              <div class="row-actions">
                <button type="button" class="btn-action edit" title="Edit reservation"
                  (click)="openEditModal(reservation)">
                  <i class="bi bi-pencil"></i>
                </button>
                <button type="button" class="btn-action delete" title="Delete reservation"
                  (click)="deleteReservation(reservation)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="pagination-bar">
    <div class="pagination-info">
      Showing <span>1</span> to <span>{{ filteredReservations().length }}</span> of <span>{{
        filteredReservations().length }}</span> reservations
    </div>
  </div>
</div>

<!-- Reservation Modal -->
<div class="modal-overlay" [class.open]="showReservationModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal modal-large">
    <div class="modal-header">
      <h2>
        <i class="bi" [class]="isEditing() ? 'bi-pencil' : 'bi-plus-circle'"></i>
        {{ isEditing() ? 'Edit Reservation' : 'New Reservation' }}
      </h2>
      <button class="close-btn" (click)="closeReservationModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      @if (isEditing()) {
        <p class="edit-hint">
          <i class="bi bi-info-circle"></i>
          You can change status and dates. Customer, equipment, branch, location, and quantity cannot be changed here.
        </p>
      }

      <div class="form-row">
        <div class="form-group">
          <label>Customer / Case <span class="required">*</span></label>
          @if (isEditing()) {
            <input type="text" [value]="editingSnapshot()?.customer ?? ''" readonly />
          } @else {
            <input type="text" placeholder="Enter customer name..." [ngModel]="formCustomer()"
              (ngModelChange)="formCustomer.set($event)" />
          }
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Branch <span class="required">*</span></label>
          @if (isEditing()) {
            <input type="text" [value]="editingSnapshot()?.branch ?? ''" readonly />
          } @else {
            <select [ngModel]="formBranch()" (ngModelChange)="onFormBranchChange($event)">
              <option value="">Select Branch</option>
              @for (branch of branches(); track branch.id) {
                <option [value]="branch.id">{{ branch.name }}</option>
              }
            </select>
          }
        </div>
        <div class="form-group">
          <label>Store Location <span class="required">*</span></label>
          @if (isEditing()) {
            <input type="text" [value]="editingSnapshot()?.location || '—'" readonly />
          } @else {
            <select [ngModel]="formLocation()" (ngModelChange)="onFormLocationChange($event)">
              <option value="">Select Location</option>
              @for (location of formBranchLocations(); track location.id) {
                <option [value]="location.id">{{ location.name }}</option>
              }
            </select>
            @if (!formLocation()) {
              <small class="field-hint">Pick a store location to filter which items are stocked there.</small>
            }
          }
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Equipment <span class="required">*</span></label>
          @if (isEditing()) {
            <input type="text" [value]="editingSnapshot()?.equipment ?? ''" readonly />
          } @else {
            <select
              [ngModel]="formEquipment()"
              (ngModelChange)="onFormEquipmentChange($event)"
              [disabled]="equipmentLoading()"
            >
              <option value="">{{ equipmentLoading() ? 'Loading equipment...' : 'Select Equipment' }}</option>
              @for (asset of availableEquipment(); track asset.id) {
              <option [value]="equipmentOptionId(asset)">{{ equipmentOptionLabel(asset) }}</option>
              }
            </select>
            @if (!equipmentLoading() && !formLocation()) {
              <small class="field-hint">Showing all Item Master items. Select a store location to see only items stocked there.</small>
            }
            @if (!equipmentLoading() && formLocation() && !availableEquipment().length) {
              <small class="field-hint">No items with stock at this location. Try another location or receive stock in Inventory.</small>
            }
          }
        </div>
        <div class="form-group">
          <label>Quantity <span class="required">*</span></label>
          @if (isEditing()) {
            <input type="number" [value]="editingSnapshot()?.quantityRequested ?? 1" readonly />
          } @else {
            <div class="qty-with-available">
              <div class="available-qty-box" [class.zero]="maxReservationQuantity() <= 0">
                <span class="available-qty-label">Available Qty</span>
                <span class="available-qty-value">{{ maxReservationQuantity() }}</span>
              </div>
              <input
                type="number"
                min="1"
                step="1"
                appDigitsOnly
                [max]="maxReservationQuantity() || 1"
                [ngModel]="formQuantity()"
                (ngModelChange)="onFormQuantityChange($event)"
                [attr.aria-describedby]="'reservation-qty-hint'"
              />
            </div>
            @if (quantityHint()) {
              <small class="field-hint" id="reservation-qty-hint">{{ quantityHint() }}</small>
            }
          }
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Start Date <span class="required">*</span></label>
          <input type="date" [ngModel]="formStartDate()" (ngModelChange)="formStartDate.set($event)" />
        </div>
        <div class="form-group">
          <label>End Date <span class="required">*</span></label>
          <input type="date" [ngModel]="formEndDate()" (ngModelChange)="formEndDate.set($event)" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Status</label>
          <select [ngModel]="formStatus()" (ngModelChange)="formStatus.set($event)">
            <option value="pending">Pending</option>
            <option value="confirmed">Confirmed</option>
            <option value="completed">Ready to issue</option>
            @if (formStatus() === 'issued' || editingSnapshot()?.status === 'issued') {
              <option value="issued">Issued out</option>
            }
            <option value="cancelled">Cancelled</option>
          </select>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" (click)="closeReservationModal()">Cancel</button>
      <button class="btn btn-primary" (click)="saveReservation()">
        <i class="bi bi-check-lg"></i> {{ isEditing() ? 'Save Changes' : 'Create Reservation' }}
      </button>
    </div>
  </div>
</div>

<!-- Toast Notification -->
<div class="toast-container" [class.show]="showToast()">
  <div
    class="toast"
    [class.success]="toastType() === 'success'"
    [class.error]="toastType() === 'error'"
    [class.info]="toastType() === 'info'"
  >
    <div class="toast-icon">
      @if (toastType() === 'error') {
        <i class="bi bi-x-circle-fill"></i>
      } @else if (toastType() === 'info') {
        <i class="bi bi-info-circle-fill"></i>
      } @else {
        <i class="bi bi-check-circle-fill"></i>
      }
    </div>
    <div class="toast-content">
      <div class="toast-title">
        {{ toastType() === 'error' ? 'Error' : toastType() === 'info' ? 'Notice' : 'Success!' }}
      </div>
      <div class="toast-message">{{ toastMessage() }}</div>
    </div>
    <button class="toast-close" (click)="closeToast()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
